import React, { InputHTMLAttributes, ReactNode, useState } from 'react';

import { Check, Eye, EyeOff } from 'lucide-react';

interface ITextInput extends InputHTMLAttributes<HTMLInputElement> {
    error?: string;
    icon?: { icon: ReactNode; position: 'prefix' | 'suffix' }
};
export const TextInput = (props: ITextInput) => {
    const { error, icon, className = '', type, disabled, ...rest } = props;

    const [inputType, setInputType] = useState(type);

    const togglePassword = () => {
        setInputType(inputType === 'password' ? 'text' : 'password');
    };

    return (
        <div className="input-group">
            <div className={`input-group--input-wrapper ${error ? 'input-group--input-wrapper--error' : ''} ${disabled ? 'input-group--input-wrapper--disabled' : ''}`}>
                {icon?.position === 'prefix' && icon.icon}
                <input
                    className={className ?? ''}
                    type={inputType}
                    disabled={disabled}
                    {...rest}
                />
                {icon?.position === 'suffix' && icon.icon}
                {type === 'password' && (
                    <button
                        type='button'
                        className='input-group--input-wrapper--password-toggle-btn'
                        onClick={togglePassword}
                    >
                        {inputType === 'password' ? <Eye /> : <EyeOff />}
                    </button>
                )}
            </div>
            {error && <p className='text-sm color--error'>{error}</p>}
        </div>
    );
};

export interface ICheckbox {
    checked: boolean;
    label: string;
    onChange: (label: string) => void;
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
};
export const Checkbox = (props: ICheckbox) => {
    const { checked, label, onChange, size = 'md', disabled } = props;

    return (
        <button
            type="button"
            disabled={disabled}
            className={`checkbox checkbox--${size} ${checked ? 'checkbox--checked' : ''} ${disabled ? 'checkbox--disabled' : ''}`}
            onClick={() => onChange(label)}
        >
            <span className='checkbox--checkmark'>
                {checked && <Check />}
            </span>
            <span className='checkbox--label'>{label}</span>
        </button>
    );
};

export interface IRadio {
    checked: boolean;
    label: string;
    value: string;
    onChange: (value: string) => void;
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
};
export const Radio = (props: IRadio) => {
    const { checked, label, value, onChange, size = 'md', disabled } = props;

    return (
        <button
            type="button"
            role="radio"
            aria-checked={checked}
            disabled={disabled}
            className={`radio radio--${size} ${checked ? 'radio--checked' : ''} ${disabled ? 'radio--disabled' : ''}`}
            onClick={() => onChange(value)}
        >
            <span className='radio--indicator'>
                <span className='radio--dot' />
            </span>
            <span className='radio--label'>{label}</span>
        </button>
    );
};

export interface ISwitch {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
};
export const Switch = (props: ISwitch) => {
    const { checked, onChange, disabled } = props;

    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            className={`switch ${checked ? 'switch--checked' : ''} ${disabled ? 'switch--disabled' : ''}`}
            onClick={() => onChange(!checked)}
        >
            <span className="switch__track">
                <span className="switch__thumb" />
            </span>
        </button>
    );
};